import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { LoginModel } from './login/loginModel';
import { environment } from '../environments/environment';
import { FunctionsService } from './services/functions.service';
import { aggressor } from './models/aggressorModel';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(
        private httpClient: HttpClient,
        private functionsService: FunctionsService
    ) { }

    public login(login: LoginModel) {
        return this.httpClient.post(environment.api + 'login',
        {
            "Email": login.Email,
            "Password": login.Password,
            "Portal": 1
        }, {withCredentials: true})

   }
    
    public updateRefreshToken(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'refreshToken/', data, { headers: headers, withCredentials: true })
    }

    public getProfilePicture() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<string>(environment.api + 'userProfile/picture', { withCredentials: true, headers: headers });
    }

    public getRoles() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + 'role',
            { withCredentials: true, headers: headers })
    }

    public getUsersPagination(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.post(environment.api + 'user/paginate/', pagination,
            { withCredentials: true, headers: headers })
    }

    public getOrganization() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get<[]>(environment.api + 'organization',
            { withCredentials: true, headers: headers })
    }

    public updateOrganization(data) {

        return this.httpClient.put(environment.api + 'organization/update/', data, { withCredentials: true})
    }

    public getOrganizationProfile() {

        return this.httpClient.get(environment.api + 'organization/profile/', { withCredentials: true })
    }

    public deleteLogo() {

        return this.httpClient.delete(environment.api + 'organization/deleteLogo/', { withCredentials: true })
    }

    public getSubscription() {

        return this.httpClient.get<[]>(environment.api + 'subscription/',
            { withCredentials: true})
    }

    public getCurrentSubscription() {

        return this.httpClient.get<[]>(environment.api + 'subscription/current/',
            { withCredentials: true })
    }

    public getSubscriptionHistory() {

        return this.httpClient.get<[]>(environment.api + 'subscriptionHistory/',
            { withCredentials: true })
    }

    public cancelSubscription(data) {

        return this.httpClient.post(environment.api + 'subscription/cancel', data, { withCredentials: true })
    }

    public reactivateSubscription(data) {

        return this.httpClient.post(environment.api + 'subscription/reactivate', data, { withCredentials: true })
    }

    public getPreferredCard() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get<[]>(environment.api + 'paymentInfo/',
            { headers: headers })
    }

    public getPreferredCardFull() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get<[]>(environment.api + 'paymentInfoFull/',
            { headers: headers })
    }

    public getCard(cardId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get<[]>(environment.api + 'getCard/'+cardId,
            { headers: headers })
    }

    public updateCard(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.put(environment.api + 'paymentInfo/updateCard/',data,
            { headers: headers })
    }

    public deleteCard(cardId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.delete(environment.api + 'paymentInfo/deleteCard/'+ cardId,
            { headers: headers })
    }

    public getPaymentMethods() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get<[]>(environment.api + 'paymentInfoList/',
            { headers: headers })
    }

    public getAlert(alertId:String) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + `alert/view/${alertId}`,
            { withCredentials: true, headers: headers })
    }

    public getAlertHistory(alertId:String) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + `alertHistory/view/${alertId}`,
            { withCredentials: true, headers: headers })
    }

    public getAlertMedia(alertId:String, compositionSid:String) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + `twilio/composition/get/${alertId}/${compositionSid}`,
            { withCredentials: true, headers: headers })
    }

    public getAlerts(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + `alert/active/`, pagination,
            { withCredentials: true, headers: headers })
    }

    public getAgents() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + 'agents/all/',
            { withCredentials: true, headers: headers })
    }

    public getAlertsPaginated(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + `alert/all/paginated/`, pagination,
            { withCredentials: true, headers: headers })
    }

    public updateAlert(alertId, createdBy, falsePositive, offZone, status) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'alert', { "Id": alertId, "CreatedBy": createdBy, "FalseAlert": falsePositive, "OffZone": offZone, "Status": status }, { withCredentials: true, headers: headers })
    }

    public verifyUser() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'user/verify',
            { withCredentials: true, headers: headers })
    }

    public getProfile(userId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'profile/' + userId,
            { withCredentials: true, headers: headers }).pipe(
                map(result => {
                    if(result['dob']){
                        result['dob'] = formatDate(result['dob'], 'yyyy-MM-dd', 'en').toString();
                    }
                    return result;
                })
            );
    }

    public getHistoryProfile(alertId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'historyProfile/' + alertId,
            { withCredentials: true, headers: headers }).pipe(
                map(result => {
                    if(result['dob']){
                        result['dob'] = formatDate(result['dob'], 'yyyy-MM-dd', 'en').toString();
                    }
                    return result;
                })
            );
    }

    public changeUserStatus(user) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'user/changeStatus', { "Id": user.id, "OrganizationId": user.organizationId, "Active": user.active }, { withCredentials: true, headers: headers })
    }

    public getUserProfile(userId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'profile/' + userId, { withCredentials: true, headers: headers }).pipe(
            map(result => {
                if(result['dob']){
                    result['dob'] = formatDate(result['dob'], 'yyyy-MM-dd', 'en').toString();
                }
                return result;
            })
        );
    }

    public getCurrentUserProfile() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'profile', { withCredentials: true, headers: headers }).pipe(
            map(result => {
                if(result['dob']){
                    result['dob'] = formatDate(result['dob'], 'yyyy-MM-dd', 'en').toString();
                }
                return result;
            })
        );
    }

    public userBulkImport(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'user/bulkImport', data, { withCredentials: true, headers: headers })
    }

    public changeOwnPassword(currentPassword: string, newPassword: string, confirmPassword: string, portal: boolean) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const request = {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword,
            portal: portal
        }

        return this.httpClient.put(environment.api + 'user/changeOwnPassword', request, { withCredentials: true, headers: headers });
    }

     public changeTempPassword(currentPassword: string, newPassword: string, confirmPassword: string) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const request = {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        }

        return this.httpClient.put(environment.api + 'user/changeTempPassword', request, { withCredentials: true, headers: headers });
    }

    public uploadOwnProfilePicture(picture: File) {

        const formData = new FormData();
        formData.append('profilePicture', picture, picture.name);
        return this.httpClient.post<string>(environment.api + 'userProfile/addPicture', formData, { withCredentials: true });
    }

    public deleteProfilePic() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'userProfile/deletePicture/', { withCredentials: true, headers: headers })
    }

    public deleteUserPic(userId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'user/deletePicture/' + userId, { withCredentials: true, headers: headers })
    }

    public createUserProfile(user) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        let request = { ...user }
        request.profile = { ...request };

        return this.httpClient.post(environment.api + 'userProfile/create/', request, { withCredentials: true, headers: headers })
    }
    
    public getDocuments(userId: number) {

        return this.httpClient.get(environment.api + `userProfile/getDocuments/${userId}`, { withCredentials: true });
    }

    public uploadDocument(userId: number, document: File) {

        const formData = new FormData();
        formData.append('userDocument', document, document.name);

        return this.httpClient.post(environment.api + `userProfile/addDocument/${userId}`, formData, { withCredentials: true });
    }

    public deleteDocument(id) {

        return this.httpClient.delete(environment.api + `userProfile/deleteDocument/${id}`, { withCredentials: true });
    }

    public uploadProfilePicture(userId: number, picture: File) {

        const formData = new FormData();
        formData.append('profilePicture', picture, picture.name);

        return this.httpClient.post(environment.api + `userProfile/addPicture/${userId}`, formData, { withCredentials: true });
    }

    public uploadLogoPicture(picture: File) {

        const formData = new FormData();
        formData.append('logo', picture, picture.name);

        return this.httpClient.post(environment.api + `organization/changeLogo/`, formData, { withCredentials: true });
    }

    public uploadOrganizationLogo(picture: File) {

        const formData = new FormData();
        formData.append('logo', picture, picture.name);

        return this.httpClient.post(environment.api + 'organization/changeLogo', formData, { withCredentials: true });
    }

    public editUserProfile(user) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'userProfile/update/', user, { withCredentials: true, headers: headers })
    }

    public editCurrentUserProfile(user) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'userProfile/updateOwn/', user, { withCredentials: true, headers: headers })
    }

    public deleteUser(userId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'user/' + userId, { withCredentials: true, headers: headers })
    }

    public getCountByStatus(monthYear) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/countByStatus/' + monthYear, { withCredentials: true, headers: headers })
    }

    public getCountOpenByStatus() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/countOpenByStatus/', { withCredentials: true, headers: headers })
    }

    public getCountByStatusUA() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/countByStatusUA/', { withCredentials: true, headers: headers })
    }

    public perTypeStatus() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'stats/perTypeStatus/' + status, { withCredentials: true, headers: headers })
    }

    public getCountByStatusType(monthYear) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/countByStatusType/' + monthYear, { withCredentials: true, headers: headers })
    }

    public getCountByOpenStatusType() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/countByOpenStatusType/', { withCredentials: true, headers: headers })
    }

    public getIncidentsByType(open, monthYear) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/perAlertType/' + open + '/' + monthYear, { withCredentials: true, headers: headers })
    }

    public getIncidentsByMonthStatus(year) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'stats/perAlertMonthStatus/'+year, { withCredentials: true, headers: headers })
    }

    public getIncidentsByMonthType(year, status) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'stats/perAlertMonthType/'+year+'/'+status, { withCredentials: true, headers: headers })
    }

    public getNotification(notificationId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get<[]>(environment.api + 'getNotification/' + notificationId,
            { withCredentials: true, headers: headers })
    }

    public getNotificationUsers(notificationId, filter) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getNotificationUsers/' + notificationId + "/" + filter, { withCredentials: true, headers: headers })
    }

    public getNotificationsPagination(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post<[]>(environment.api + 'notification/paginate/', pagination,
            { withCredentials: true, headers: headers })
    }

    public saveNotification(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'notification/', notification, { withCredentials: true, headers: headers })
    }

    public editNotification(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'notification/', notification, { withCredentials: true, headers: headers })
    }

    public sendNotification(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'notifications/send', notification, { withCredentials: true, headers: headers })
    }

    public sendNotificationOptions(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'notifications/sendOptions', notification, { withCredentials: true, headers: headers })
    }

    public updateSentStatus(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'notification/updateStatus', notification, { withCredentials: true, headers: headers })
    }

    public cancelNotification(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'notification/cancel/', notification, { withCredentials: true, headers: headers })
    }

    public deleteNotification(notification) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(`${environment.api}notification/delete`, notification, { withCredentials: true, headers: headers })
    }

    public forgotPassword(email){
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.httpClient.post(environment.api + 'forgotPassword/', email, { withCredentials: true, headers: headers })
    }

    public resetPassword(password){
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.httpClient.post(environment.api + 'resetPassword/', password, { withCredentials: true, headers: headers })
    }

    public resetUserPassword(user){
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        })
        return this.httpClient.post(environment.api + 'user/resetPassword/', user, { withCredentials: true, headers: headers })
    }

    public validateToken(token){
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.httpClient.post(environment.api + 'validateToken/', token, { withCredentials: true, headers: headers })
    }

    public verifyTempPass(account){
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.httpClient.post(environment.api + 'verifyTempPass/', account, { withCredentials: true, headers: headers })
    }

    public getGroup(id){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.get(environment.api + 'group/'+id,
            { withCredentials: true, headers: headers })
    }

    public getGroupUsers(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'group/users/', pagination,
            { withCredentials: true, headers: headers })
    }

    public getUsersNotInGroup(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        }); 
        return this.httpClient.post(environment.api + 'group/not/users/', pagination,
        { withCredentials: true, headers: headers })
    }

    public removeGroupUsers(groupId, userList) {
        var groupObject = {"GroupId":groupId, "UserList": userList};
        return this.httpClient.post(environment.api + `groupUsers/`, groupObject, { withCredentials: true });
    }

    public addGroupUsers(groupId, userList) {
        var groupObject = {"GroupId":groupId, "UserList": userList};
        return this.httpClient.post(environment.api + `groupUsers/add`, groupObject, { withCredentials: true });
    }

    public getGroups(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'groups/all/',
            { withCredentials: true, headers: headers })
    }

    public addGroup(group) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'group/create/', group, { withCredentials: true, headers: headers })
    }

    public editGroup(id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'group/update/', id, { withCredentials: true, headers: headers })
    }
 
    public deleteGroup(id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'group/' + id, { withCredentials: true, headers: headers })
    }

    public getUserGroups(userId){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'userGroup/' + userId,
            { withCredentials: true, headers: headers })
    }

    public getUserGroupsCounted(userId){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'userGroupCounted/' + userId,
            { withCredentials: true, headers: headers })
    }

    public saveUserGroups(userId,group) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'userGroup/'+userId, group, { withCredentials: true, headers: headers })
    }

    public deleteUserGroup(userId,group) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'userGroup/'+userId+'/'+group, { withCredentials: true, headers: headers })
    }

    public getAlertPositions(alertId,  positionAmount, history){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'position/' + alertId + '/' +  positionAmount + '/' + history,
            { withCredentials: true, headers: headers })
    }

    public getLatestPositionAlert(alertId){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'position/last/' + alertId,
            { withCredentials: true, headers: headers })
    }

    public getAlertsByDateRange(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'stats/alertsByRange/', pagination,
            { withCredentials: true, headers: headers })
    }

    public validateCode(data){
        return this.httpClient.post(environment.api + 'register/validateCode', data, {withCredentials: true})
    }

    public resendCode(data){
        return this.httpClient.post(environment.api + 'register/resendCode', data, {withCredentials: true})
    }

    public resendPassword(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'user/resendPassword', data, 
            { withCredentials: true, headers: headers })
    }

    public registerTrial(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'register/trial', data, { withCredentials: true, headers: headers })
    }

    public getUserCount() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'userCount/', { withCredentials: true, headers: headers })
    }

    public getGeoZoneLogs(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'geoZoneLog', pagination, {withCredentials: true, headers: headers})
    }

    public getZone(id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'zone/'+id, { withCredentials: true, headers: headers })
    }

    public getZones() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'zone/all', { withCredentials: true, headers: headers })
    }

    public getOrgZones(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'zones', { withCredentials: true, headers: headers })
    }

    public addZone(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'zone/add', data, { withCredentials: true, headers: headers })
    }

    public editZone(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'zone/update', data, { withCredentials: true, headers: headers })
    }

    public deleteZone(id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.delete(environment.api + 'zone/delete/' + id, { withCredentials: true, headers: headers })
    }

    public changeZoneStatus(zone) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            
        });
        return this.httpClient.put(environment.api + 'zone/changeStatus', { "Id": zone.id, "Active": zone.active, "Name": zone.name}, { withCredentials: true, headers: headers })
    }

    public getZoneUsers(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'zone/users/', pagination,
            { withCredentials: true, headers: headers })
    }

    public getUsersNotInZone(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        }); 
        return this.httpClient.post(environment.api + 'zone/not/users/', pagination,
        { withCredentials: true, headers: headers })
    }

    public addZoneUsers(zoneId, userList) {
        var zoneObject = {"ZoneId":zoneId, "UserList": userList};
        return this.httpClient.post(environment.api + `zoneUsers/add`, zoneObject, { withCredentials: true });
    }

    public removeZoneUsers(zoneId, userList) {
        var zoneObject = {"ZoneId":zoneId, "UserList": userList};
        return this.httpClient.post(environment.api + `zoneUsers/`, zoneObject, { withCredentials: true });
    }

    public getStatus(alertId){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alert/getStatus/'+alertId,
            { withCredentials: true, headers: headers })
    }

    public getGoogleToken(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.httpClient.get(environment.api + 'googleToken',
            { withCredentials: true, headers: headers, responseType: 'text'})
    }

    public sendOldChatNotiFireBase(message) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'key=AAAAztjI4Wo:APA91bGaMnsKHp1AFjyCYm8y5XY6g9Q_o0Y_Wqoxyi68Gm-J7lo_kJrDADZHuo3oJfahsLvrzxb1j6qrKVogoodgPobBmSZS6U3IC_BJBaZbQ3rmS8Jzr03EkcTXo9brQ8HbDKpvHpdu'
        });
        return this.httpClient.post('https://fcm.googleapis.com/fcm/send', message, { withCredentials: true, headers: headers })
    }

    public sendChatNotiFireBase(message, token) {
    var headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    });
    return this.httpClient.post('https://fcm.googleapis.com/v1/projects/alertia-panicalert-msjcontigo/messages:send', message, { headers: headers })
    }

    public getAlertLogs(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'alertLogs/', pagination,
            { withCredentials: true, headers: headers })
    }

    public addAlertNote(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'alertNote', data, { withCredentials: true, headers: headers })
    }

    public getPossibleAttendees(attendedBy){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alert/possibleAttendees/'+attendedBy,
            { withCredentials: true, headers: headers })
    }
    
    public reassignAlert(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'alert/reassign', data, { withCredentials: true, headers: headers })
    }

    public getModalTimer(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getModalTimer/', { withCredentials: true, headers: headers })
    }

    public getLanguage(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getLanguage/', { withCredentials: true, headers: headers })
    }

    public setLanguage(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'languageSetting/', data, { withCredentials: true, headers: headers })
    }

    public changeAlertType(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'alert/updateType/', data, { withCredentials: true, headers: headers })
    }

    public getOutZoneMessage(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'zone/message', { withCredentials: true, headers: headers })
    }

    public updateOutZoneMessage(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'zone/message', data, { withCredentials: true, headers: headers })
    }

    public markOutOfZone(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.put(environment.api + 'alert/outOfZone', data, { withCredentials: true, headers: headers })
    }

    public getNotificationApprovers(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'getApprovers/', pagination, { withCredentials: true, headers: headers })
    }

    public getPotentialApprovers(pagination){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'getPotentialApprovers/', pagination, { withCredentials: true, headers: headers })
    }

    public updateApproveNotiStatus(value){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        var notificationApproval = {"Approve":value};
        return this.httpClient.post(environment.api + 'notification/approve/', notificationApproval, { withCredentials: true, headers: headers })
    }

    public approveNotificationsStatus(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'notification/approvalStatus', { withCredentials: true, headers: headers })
    }

    public addNotiApprovers(userList) {
        var userObject = {"UserList": userList};
        return this.httpClient.post(environment.api + `notificationApprovers/add`, userObject, { withCredentials: true });
    }

    public removeNotiApprovers(userList) {
        var userObject = {"UserList": userList};
        return this.httpClient.post(environment.api + `notificationApprovers/remove`, userObject, { withCredentials: true });
    }

    public isApprover() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'notification/approver', { withCredentials: true, headers: headers })
    }

    public getUnapprovedNotifications(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'notification/unapproved/paginate', data, { withCredentials: true, headers: headers })
    }

    public changeSelectedNotificationsStatus(notificationList, approve) {
        var notificationObject = {"NotificationList": notificationList, "Approve": approve};
        return this.httpClient.post(environment.api + `notification/changeStatus`, notificationObject, { withCredentials: true });
    }

    public getCustomAlertType(id) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alertType/' + id, { withCredentials: true, headers: headers })
    }

    public getCustomAlertTypes(active) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alertTypes/' + active, { withCredentials: true, headers: headers })
    }

    public getOpenClosedAlertTypes(active) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alertTypes/oc/' + active, { withCredentials: true, headers: headers })
    }

    public getAlertZones() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'alert/zones', { withCredentials: true, headers: headers })
    }

    public getAssignedZone() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'zone/userAssignedZone', { withCredentials: true, headers: headers })
    }

    public getClosedAlertGroups() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'group/Filter', { withCredentials: true, headers: headers })
    }

    public addCustomAlertType(alertType) {

        return this.httpClient.post(environment.api + 'alertType/', alertType, { withCredentials: true });
    }

    public editCustomAlertType(alertType) {

        return this.httpClient.put(environment.api + 'alertType/', alertType, { withCredentials: true });
    }

    public deleteCustomAlertType(id) {

        return this.httpClient.delete(environment.api + 'alertType/' + id, { withCredentials: true });
    }

    public subscriptionStartDate() {

        return this.httpClient.get(environment.api + 'subscriptionHistory/startDate', { withCredentials: true });
    }

    public alertStartDate(id) {

        return this.httpClient.get(environment.api + 'alert/startDate/' + id, { withCredentials: true });
    }

    public alertHistoryExport(historyFilter) {
        return this.httpClient.post(environment.api + 'alert/historyExport/', historyFilter, { withCredentials: true });
    }

    public alertLogExport(logFilter) {
        return this.httpClient.post(environment.api + 'alert/logExport/', logFilter, { withCredentials: true });
    }

    public getPreconfiguredMessages() {

        return this.httpClient.get(environment.api + 'preconfiguredMessages', { withCredentials: true });
    }

    public getPreconfiguredMessage(id) {

        return this.httpClient.get(environment.api + 'preconfiguredMessage/' + id, { withCredentials: true });
    }

    public addPreconfiguredMessage(data) {
        return this.httpClient.post(environment.api + 'preconfiguredMessage/add', data, { withCredentials: true });
    }

    public updatePreconfiguredMessage(data) {
        return this.httpClient.put(environment.api + 'preconfiguredMessage/update', data, { withCredentials: true });
    }

    public deletePreconfiguredMessage(id) {
        return this.httpClient.delete(environment.api + 'preconfiguredMessage/delete/' + id, { withCredentials: true });
    }

    public editMessageOrder(data) {
        return this.httpClient.put(environment.api + 'preconfiguredMessages/editOrder', data, { withCredentials: true });
    }

    public getCustomFields() {

        return this.httpClient.get(environment.api + 'customFields', { withCredentials: true });
    }

    public setTimeConfiguration(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'updateTimeConfiguration/', data, { withCredentials: true, headers: headers })
    }

    public getTimeConfiguration(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getTimeConfiguration/', { withCredentials: true, headers: headers })
    }

    public getFieldsName(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'customFieldsName/' + data, { withCredentials: true, headers: headers })
    }

    public setAgentDispatchConfiguration(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post(environment.api + 'updateDispatchConfiguration/', data, { withCredentials: true, headers: headers })
    }

    public getAgentDispatchConfiguration(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getDispatchConfiguration/', { withCredentials: true, headers: headers })
    }

    public getAgentDispatchGeoAssignment(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.get(environment.api + 'getAgentDispatch/', { withCredentials: true, headers: headers })
    }

    public getRejectionMessages() {

        return this.httpClient.get(environment.api + 'rejectionMessages', { withCredentials: true });
    }

    public addRejectionMessage(data) {
        return this.httpClient.post(environment.api + 'rejectionMessage/add', data, { withCredentials: true });
    }

    public getRejectionMessage(id) {

        return this.httpClient.get(environment.api + 'rejectionMessage/' + id, { withCredentials: true });
    }
    
    public updateRejectionMessage(data) {
        return this.httpClient.put(environment.api + 'rejectionMessage/update', data, { withCredentials: true });
    }

    public deleteRejectionMessage(id) {
        return this.httpClient.delete(environment.api + 'rejectionMessage/delete/' + id, { withCredentials: true });
    }

    public editRejectionMessageOrder(data) {
        return this.httpClient.put(environment.api + 'rejectionMessages/editOrder', data, { withCredentials: true });
    }

    public verifyAlertsInZone(id){
        return this.httpClient.get(environment.api + 'zoneAttendingAlert/' + id, { withCredentials: true });
    }

    public getAgentsInField(pagination) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this.httpClient.post<[]>(environment.api + 'agentsInField/', pagination,
            { withCredentials: true, headers: headers })
    }


    public getPaymentsByDateRange(startDate, endDate){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'payment/paymentsByRange/' + startDate + '/' + endDate,
            { headers: headers })
    }

    public register(data){
        return this.httpClient.post(environment.api + 'register', data)
    }

   
    public getCart(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'cart/',
            { headers: headers })
    }

    public getPlan(planId){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'plan/'+planId,
            { headers: headers })
    }

    public getPlans(){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'plans/'+1,
            { headers: headers })
    }

    public updateCart(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'cart/update', data, { headers: headers })
    }

    public processInitialPayment(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'payment/initial', data, { headers: headers })
    }

    public processNewPayment(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'payment/new', data, { headers: headers })
    }

    public addCard(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'paymentInfo/', data, { headers: headers })
    }

    public changePreferredCard(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'preferredCard/', data, { headers: headers })
    }

    public getPeriod(id) {
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });

        return this.httpClient.get(environment.api + `period/${id}`, { headers: headers });
    }

    public getPaymentHistory() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'payment/all/', { headers: headers })
    }

    public changeBillingCycle() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'subscription/changeBilling/', { headers: headers })
    }

    public keepCurrentPlan() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'subscription/keepPlan/', { headers: headers })
    }

    public getPaymentInfoReceipt(paymentId) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'payment/info/' + paymentId, { headers: headers })
    }

    public processExistingPayment(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'payment/existing/', data, { headers: headers })
    }

    public prorateProcess() {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.get(environment.api + 'subscription/prorate/', { headers: headers })
    }

    public prorateExistingPayment(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'payment/existing/prorate/', data, { headers: headers })
    }

    public prorateNewPayment(data) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'payment/new/prorate/', data, { headers: headers })
    }

   
    public sendTwilioNoti(identity, from, body) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'twilio/sendNotification', {"Identity":identity, "From": from, "Body":body}, { headers: headers })
    }

    public getCustomField(id) {


        return this.httpClient.get(environment.api + 'customField/' + id, { withCredentials: true  });
    }
    public addCustomField(data) {

        return this.httpClient.post(environment.api + 'customFields/add', data, { withCredentials: true });
    }
    public updateCustomField(data) {

        return this.httpClient.put(environment.api + 'customFields/update', data, { withCredentials: true });
    }
    public deleteCustomField(id) {

        return this.httpClient.delete(environment.api + 'customFields/delete/' + id, { withCredentials: true  });
    }
    public editFieldOrder(data) {

        return this.httpClient.put(environment.api + 'customFields/editOrder', data, { withCredentials: true });
    }
    public getUserFieldOption(){
        // var headers = new HttpHeaders({
        //     'Content-Type': 'application/json',
        //     'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        // });
        // return this.httpClient.get(environment.api + , { headers: headers })
        return this.httpClient.get(environment.api + 'getUserFieldOption/', { withCredentials: true });

    }

   
    public setUserFieldOption(data){
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        });
        return this.httpClient.post(environment.api + 'userFieldOptionSetting/', data, { withCredentials: true  })
    }

   
    public getAgentDispatch(){

        return this.httpClient.get(environment.api + 'getAgentDispatch/', { withCredentials: true })
    }

    public getGeoAssignment(){

        return this.httpClient.get(environment.api + 'getGeoAssignment/', {  withCredentials: true })
    }



    public getAggressorsByParticipant(participantId: string): Observable<any[]> {
        // return this.http.get<any[]>(`${this.apiUrl}/api/aggressors/participant/${participantId}`);
        console.log("servicio", participantId)
        return this.httpClient.get<aggressor[]>(environment.api + `aggressors/participant/${participantId}`, { withCredentials: true });
    }


createAggressor(formData): Observable<any> {
  return this.httpClient.post(`${environment.api}` + `aggressors`, formData, { withCredentials: true });
}


deleteAggressor(id: number, deleteRequest: { deleteReason: string }): Observable<any> {
    console.log('delete aggressor', id, deleteRequest);
  return this.httpClient.put(`${environment.api}` + `aggressors/${id}/delete`, deleteRequest, {
    withCredentials: true
  });
}

getAggressorById(id: string): Observable<any> {
  return this.httpClient.get<any>(`${environment.api}` + `aggressors/${id}`, { withCredentials: true });
}

updateAggressor(id: string, aggressorData: any): Observable<any> {
  return this.httpClient.put( `${environment.api}` + `aggressors/${id}`, aggressorData, { withCredentials: true });
}



uploadAggressorPicture(aggressorId: number, picture: File): Observable<string> {
  const formData = new FormData();
  formData.append('aggressorPicture', picture, picture.name);
  return this.httpClient.post<string>(environment.api + `aggressors/${aggressorId}/addPicture`, formData, { withCredentials: true });
}

}
